const DEFAULT_THRESHOLD = 20;
export const DEFAULT_FEED_MODE = 'ground';
export const DEFAULT_FEED_RATE = 'avg';

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function normalizeRefillThreshold(value, fallback = DEFAULT_THRESHOLD) {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return clamp(fallback, 0, 100);
  }
  return clamp(value, 0, 100);
}

function buildFeedingPayload({
  feed,
  feedingMode,
  feedCapacityLbs,
  consumptionRateCode,
  refillThresholdPct
}) {
  if (!feed) {
    return {
      feeding_mode: null,
      consumption_rate_code: null,
      feed_capacity_lbs: null
    };
  }
  const normalizedMode = feedingMode === 'hopper' ? 'hopper' : DEFAULT_FEED_MODE;
  const payload = {
    feeding_mode: normalizedMode,
    consumption_rate_code: consumptionRateCode || DEFAULT_FEED_RATE
  };
  if (normalizedMode === 'hopper') {
    payload.feed_capacity_lbs = Number.isFinite(feedCapacityLbs) && feedCapacityLbs > 0
      ? Math.round(feedCapacityLbs)
      : null;
    payload.refill_threshold_pct = normalizeRefillThreshold(refillThresholdPct);
  } else {
    payload.feed_capacity_lbs = null;
  }
  return payload;
}

export {
  buildFeedingPayload,
  normalizeRefillThreshold
};
